import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import BrandMark from "./BrandMark";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/servicos", label: "Serviços" },
  { to: "/galeria", label: "Galeria" },
  { to: "/loja", label: "Pre-Shop" },
  { to: "/agendamentos", label: "Agendar" },
  { to: "/contactos", label: "Contactos" },
];

const Navbar = () => {
  const { count, setIsOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-beige/95 backdrop-blur-md border-b border-gold/15 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="container-luxe flex items-center justify-between">
        <BrandMark size={scrolled ? "sm" : "md"} />

        <nav className="hidden lg:flex items-center gap-8" aria-label="Principal">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace("/", "") || "home"}-link`}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="open-cart-btn"
            onClick={() => setIsOpen(true)}
            aria-label="Abrir carrinho"
            className="relative p-3 text-ink hover:text-gold transition-colors"
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-0.5 -right-0.5 bg-gold-bright text-ink text-[10px] font-semibold rounded-full w-5 h-5 flex items-center justify-center shadow-[0_0_8px_rgba(255,215,0,0.6)]"
              >
                {count}
              </span>
            )}
          </button>

          <button
            data-testid="mobile-menu-btn"
            onClick={() => setMobileOpen((v) => !v)}
            className="lg:hidden p-3 text-ink"
            aria-label="Menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-beige border-t border-gold/15 mt-3"
        >
          <div className="container-luxe py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `text-base tracking-[0.2em] uppercase py-2 ${
                    isActive ? "text-gold" : "text-ink/80"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
